export const postHogConfig = {
  enabled: import.meta.env.VITE_POSTHOG_ENABLED === "true" || false,
  apiKey: import.meta.env.VITE_POSTHOG_API_KEY || null,
  host: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
  replayEnabled:
    import.meta.env.VITE_POSTHOG_REPLAY_ENABLED === "true" || false,
  pageTrackingEnabled:
    import.meta.env.VITE_POSTHOG_PAGE_TRACKING_ENABLED === "true" || false,
};
